import { BtnCleanProjectList } from "../../../components/BtnCleanProjectList";
import { CustomPageHeading } from "../../../components/CustomPageHeading/CustomPageHeading";
import { BtnImportConfigId } from "../../../components/common/BtnImportConfigId/BtnImportConfigId";
import { useUiTranslator } from "../../../hooks/useUiTranslator";
import { useOnboardingStatus } from "../../../onboarding/useOnboardingStatus";

import { ReactNode } from "react";

import AddIcon from "@mui/icons-material/Add";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams, useSearch } from "@tanstack/react-router";

export function CartViewHeading({
  itemGroupId,
  administrationArea,
}: {
  itemGroupId: string;
  administrationArea: string | undefined;
}): ReactNode {
  const t = useUiTranslator();
  const navigate = useNavigate();
  const onboardingStatus = useOnboardingStatus();

  const { productCategory } = useSearch({ strict: false });

  const { cartId: quoteId } = useParams({
    strict: false,
  });

  function routeToConfigurator(): void {
    navigate({
      to: `/configurator?cfgObjectId=&productId=&quoteId=${quoteId}&itemGroupId=${itemGroupId}&lineItemId=&administrationArea=${administrationArea}&productCategory=${productCategory}`,
    });
  }

  if (productCategory && administrationArea && onboardingStatus === "ready") {
    navigate({
      to: `/configurator?cfgObjectId=CFG_PROFESSIONAL&productId=&quoteId=${quoteId}&itemGroupId=${itemGroupId}&lineItemId=&administrationArea=${administrationArea}&productCategory=${productCategory}`,
    });
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <CustomPageHeading
        text={t("CustomApp:header.cart.title", "Project list-test")}
        //subtitle={item.name}
      />
      <Box
        display="flex"
        gap={2}
        sx={{ mt: "1rem", marginRight: "1rem", marginBottom: "rem" }}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={routeToConfigurator}
        >
          <Typography>
            {t("CustomApp:cartViewHeader.button.title", "New Configuration")}
          </Typography>
        </Button>
        <BtnImportConfigId />

        <BtnCleanProjectList />
      </Box>
    </Box>
  );
}
